class SmartListsController {

    constructor() {

        this._smartListsData = new SmartListsData();
        this._loadTemplates();

    }

    _loadTemplates() {

        Handlebars.registerPartial("SLContentSpecialPoll", $("#SLContentSpecialPoll").html());
        Handlebars.registerPartial("SLContentSpecialTest", $("#SLContentSpecialTest").html());
        Handlebars.registerPartial("SLContentSpecialGame", $("#SLContentSpecialGame").html());
        Handlebars.registerPartial("SLContentSpecialTask", $("#SLContentSpecialTask").html());

        Handlebars.registerPartial("SLContentHighlight", $("#SLContentHighlight").html());
        Handlebars.registerPartial("SLContentCover", $("#SLContentCover").html());
        Handlebars.registerPartial("SLContentCardSquare", $("#SLContentCardSquare").html());
        Handlebars.registerPartial("SLContentCardArt", $("#SLContentCardArt").html());
        Handlebars.registerPartial("SLContentCardTall", $("#SLContentCardTall").html());
        Handlebars.registerPartial("SLContentCardWide", $("#SLContentCardWide").html());
        Handlebars.registerPartial("SLContentList", $("#SLContentList").html());
        Handlebars.registerPartial("SLContentWall", $("#SLContentWall").html());

        Handlebars.registerPartial("SLFormatCarousel", $("#SLFormatCarousel").html());
        Handlebars.registerPartial("SLFormatList", $("#SLFormatList").html());
        Handlebars.registerPartial("SLFormatGrid", $("#SLFormatGrid").html());

        Handlebars.registerPartial("SLSectionHeader", $("#SLSectionHeader").html());

    }

    getSmartListsDictViews() {
        return this._smartListsData.getSmartListsDictViews();
    }

    getSmartListName(smartListId) {
        const smartListsDictIds = this._smartListsData.getSmartListsDictIds();
        return smartListsDictIds[smartListId];
    }

    getDraggingCarousel() {
        return this._smartListsData.getDraggingCarousel();
    }


    setTitleEllipsis() {

        function applyEllipsis() {

            const $this = $(this);
            const $smartListTitle = $this.find("p.title");
            const smartListType = $this.data("list");
            let dotOptions = {wrap: 'word', watch: true};

            if ($smartListTitle.hasClass("big")) {
                dotOptions.height = 135;
            } else if ($smartListTitle.hasClass("small")) {
                dotOptions.height = 48;
            } else if (smartListType === "SPECIAL_POLL") {
                dotOptions.height = 44;
            } else {
                dotOptions.height = 66;
            }

            $smartListTitle.dotdotdot(dotOptions);

        }

        const $smartLists = $("div.bf-smart-list");
        $smartLists.each(applyEllipsis);

    }

    setCarousels() {

        function _onDragged() {

            // FIX Evitar entrar en los contenidos al hacer drag.
            setTimeout(function() {
                that._smartListsData.setDraggingCarousel(false);
            }, 250);

        }

        const $smartListCarousel = $("div.carousel-format.smart-list");
        const that = this;
        const owlCarouselOptions = {
            checkVisible: false,
            autoWidth: true,
            dots: false,
            onDragged: _onDragged
        };

        $smartListCarousel.owlCarousel(owlCarouselOptions);

        $smartListCarousel.off("drag.owl.carousel").on("drag.owl.carousel", function () {
            that._smartListsData.setDraggingCarousel(true);
        });

    }

    setHeaders() {

        function applyCollapsible(event) {

            const $target = $(event.target);

            if (!$target.hasClass("see-all-button")) {

                const $this = $(this);
                const dataId = $this.data("id");
                const $selectedHeader = $("div.smart-list-section[data-id=" + dataId + "]");

                $selectedHeader.toggleClass("collapsed");

            }

        }

        function applyEllipsis() {

            const $this = $(this);
            const $headersTitle = $this.find("p.title");
            const dotOptions = {wrap: 'word', watch: true, height: 44};

            $headersTitle.dotdotdot(dotOptions);

        }

        const $collapsibleHeaders = $("div.smart-list-section > .header.collapsible");
        const $smartListHeaders = $("div.smart-list-section > .header");

        $collapsibleHeaders.on("click.collapsible", applyCollapsible);
        $smartListHeaders.each(applyEllipsis);

    }

    setMargins() {

        const $smartLists = $("div.smart-list");

        $smartLists.each(function() {

            const $currentSmartList = $(this);
            const $smartListItems = $currentSmartList.find("div.list-item");
            const smartListFormat = $currentSmartList.data("format");
            const visibleCategories = $currentSmartList.find(".footer").length > 0;
            const numberOfListItems = $smartListItems.length - 1;

            if (smartListFormat === "list") {

                $smartListItems.each(function() {

                    const $currentItem = $(this);
                    const currentIndex = parseInt($currentItem.data("index"));
                    const currentHasSpecialView = $currentItem.data("special");
                    const currentIsCard = ["CARD_SQUARE", "CARD_TALL", "CARD_WIDE", "CARD_ART"].indexOf($currentItem.data("list")) >= 0;

                    const $nextItem = $currentSmartList.find("div.list-item[data-index=" + (currentIndex + 1) + "]");
                    const nextHasSpecialView = $nextItem.data("special");
                    const nextIsCard = ["CARD_SQUARE", "CARD_TALL", "CARD_WIDE", "CARD_ART"].indexOf($currentItem.data("list")) >= 0;

                    const $currentSmartListItem = $currentItem.find(".bf-smart-list");

                    if (currentHasSpecialView || currentIsCard) {

                        $currentSmartListItem.addClass("current-has-special-view");

                        if (visibleCategories) {
                            $currentSmartListItem.addClass("is-category-visible");
                        }

                        if (!nextHasSpecialView && !nextIsCard) {
                            $currentSmartListItem.addClass("next-not-has-special-view");
                        }

                    }

                    if (currentIndex === numberOfListItems) {

                        if (currentHasSpecialView || currentIsCard) {
                            $currentSmartListItem.addClass("last-has-special-view");
                        }

                    }

                });

            }

        });

    }

    initialize() {

        this.setTitleEllipsis();
        this.setCarousels();
        this.setHeaders();
        this.setMargins();

    }

}
